<template>
  <v-dialog
    :model-value="dialog"
    id="dialog-terms-conditions"
    content-class="i-dialog"
    width="900"
    persistent
  >
    <v-card>
      <template>
        <v-card-title class="i-dialog-header-div">
          <span class="g-heading-m g-bold">Terms & Conditions</span>
        </v-card-title>

        <v-card-text
          class="my-0 py-0"
          :class="{ 'i-dialog-content-div-large': $vuetifyDisplay.mdAndUp }"
        >
          <div class="my-5 my-md-8">
            <i-terms-conditions-text />
          </div>

          <v-divider></v-divider>

          <div class="mt-7 mb-2 py-0">
            <v-checkbox
              class="my-0 py-0"
              v-model="acceptTermsConditions"
              :rules="[
                (v) =>
                  !!v || 'You must accept our Terms & Conditions to proceed.'
              ]"
              required
            >
              <template v-slot:label>
                <div>
                  Yes, I have read and accept the Flewid Technologies
                  <span class="g-bold">Terms & Conditions</span>.
                </div>
              </template>
            </v-checkbox>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions
          class="i-dialog-actions-div justify-center justify-sm-end"
        >
          <v-btn
            large
            rounded
            text
            class="i-btn-text-black"
            @click="handleClose"
          >
            Back
          </v-btn>

          <v-btn
            large
            rounded
            class="i-btn-block-secondary mr-4"
            :loading="loading"
            :disabled="!acceptTermsConditions"
            @click="handleConfirm"
          >
            Confirm
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import iTermsConditionsText from '../components/TermsConditionsText.vue'

export default {
  components: {
    iTermsConditionsText
  },

  data: () => ({
    acceptTermsConditions: false
  }),

  props: {
    dialog: {
      default: false,
      required: true,
      type: Boolean
    },

    loading: {
      default: false,
      type: Boolean
    }
  },

  methods: {
    handleClose() {
      this.acceptTermsConditions = false
      this.$emit('cancel')
    },

    handleConfirm() {
      this.$emit('confirm')
    }
  }
}
</script>
